import React, { Component } from "react";
import VehicleTypeCountPageUI from "./VehicleTypeCountPageUI";
import CacheManager from "../../../cache/CacheManager";
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";

class VehicleTypeCountPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            vehicleTypeSummary: null,
            vehicleTypeDetails: null,
            response: null
        }
    }

    render() {
        return (
            <VehicleTypeCountPageUI
                context={this.props.context}
                errorList={this.state.errorList}
                response={this.state.response}
                vehicleTypeSummary={this.state.vehicleTypeSummary}
                vehicleTypeDetails={this.state.vehicleTypeDetails}
                onRefreshClick={this.onRefreshClick}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getVehicleTypeData(context);
    }


    getVehicleTypeData(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/loans/vehicleTypes`,
            cacheKey: CacheKeys.VehicleTypeList(),
            callback: this.getVehicleTypeDataCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }
    getVehicleTypeDataCallback = (response) => {
        this.setState({
            vehicleTypeSummary: response.loanVehicleTypeTotalList,
            vehicleTypeDetails: response.loanVehicleTypeList,
            response: response,
            errorList: response.errorList
        });
    };

    onRefreshClick = () => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.VehicleTypeList())
        this.setState({
            vehicleTypeSummary: null,
            vehicleTypeDetails: null,
            response: null
        });
        this.getVehicleTypeData(context);
    };
}

export default VehicleTypeCountPageSF